import { Component, EventEmitter, Input, OnChanges, Output, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Event } from "../../../../../models/event";
import { EventType } from "../../../../../models/event-type";
import { PrintDocument } from "../../../../../models/print-document";
import { Role } from "../../../../../models/role";
import { RoleRegistration } from "../../../../../models/role-registration";
import { RoleStatus } from "../../../../../models/role-status";
import { FormControllerService } from "../../../../../services/form-controller/form-controller.service";
import { PrintDocumentControllerService } from "../../../../../services/print-document/print-document-controller.service";
import { RoleControllerService } from "../../../../../services/role-controller/role-controller.service";
import { RoleStatusControllerService } from "../../../../../services/role-controller/role-status-controller.service";
import { RoleService } from "../../../../../services/role-controller/role.service";
import { Store } from "../../../../../services/store.service";
import {TranslatedBaseError} from "../../../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "bot-manage",
  templateUrl: "./bot-manage.component.html",
  providers: [RoleControllerService, FormControllerService, RoleStatusControllerService, ToastrService, PrintDocumentControllerService],
})
export class BotManageComponent extends TranslatedBaseError implements OnInit, OnChanges {

  @Input() public role = new Role();
  @Input() public serviceId: string;
  @Input() public fromRole: boolean = false;
  @Output() public modalAddedEvent = new EventEmitter();
  @Output() public changedData = new EventEmitter();

  public serviceRoles: Role[];
  public statuses: RoleStatus[];
  public roleId: string;
  public registrations: RoleRegistration[];
  public roleInstitutionsLength: number = 0;
  public roleUnitsLength: number = 0;

  public showDeterminant: boolean = false;
  public initialValue: string = "";

  public printDocuments: PrintDocument[];

  public newRole: any;

  public isLoading: boolean = false;
  @Output() public addedFromRoleEvent = new EventEmitter();

  constructor(private roleController: RoleControllerService,
              private printDocController: PrintDocumentControllerService,
              private roleService: RoleService,
              private router: Router,
              public store: Store,
              private route: ActivatedRoute,
              toastr: ToastrService,
              public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnChanges() {
    if (!this.fromRole) {
      if (this.role && !this.role.id) {
        this.reloadRole();
        this.getServiceRolesList();
      } else if (this.role) {
        this.uploadData(this.role);
      }
    }
  }

  public ngOnInit() {
    this.printDocController.getDocumentList(this.serviceId, true).subscribe(
      (data) => {
        this.printDocuments = data;
      },
    );
  }

  public addNewRole() {
    if (!this.isLoading) {
      this.isLoading = true;
      this.role.isFrontendBot = true;
      this.role.type = "BotRole";

      this.roleController.createBotRole(this.serviceId, this.role).subscribe(
        (data) => {
          this.newRole = data;
          this.responseSuccessful("Bot role created!");
          if (!this.fromRole) {
            this.modalAddedEvent.emit(new Event(null, EventType.Add));
          } else {
            this.addedFromRoleEvent.emit(data);
          }
          /*for (let j = this.newRole.statuses.length - 1; j >= 0; j--) {
            if (this.newRole.statuses[j].roleStatusType === "FileDeclineStatus") {
              this.newRole.statuses[j].active = true;
              this.newRole.statuses[j].destinations = [];
              this.serviceRoles.forEach((role) => {
                if (role.assignedTo === "applicant") {
                  this.newRole.statuses[j].destinations.push({ destinationId: role.id });
                }
              });
              this.roleStatusControllerService.saveRoleFileDeclineStatus(this.newRole.statuses[j].id, this.newRole.statuses[j]).subscribe(
                (statusData) => {
                  this.modalAddedEvent.emit(new Event(null, EventType.Add));
                },
                (error) => this.showErrorMessage(error),
                () => this.isLoading = false,
              );
            }
          }*/
        },
        (error) => {
          this.isLoading = false;
          this.showErrorMessage(error);
        },
      );
    }
  }

  public saveRole() {
    if (this.role && this.role.id) {
      if (this.role.type === "UserRole") {
        this.roleController.saveUserRole(this.role).subscribe(
          () => {
            this.responseSuccessful("User role saved!");
            this.roleService.changeMade();
            this.changedData.emit();
          },
          (error) => this.showErrorMessageWithTitle("Role saving error!", error),
        );
      } else if (this.role.type === "BotRole") {
        this.roleController.saveBotRole(this.role).subscribe(
          () => {
            this.responseSuccessful("BOT role saved!");
            this.roleService.changeMade();
            this.changedData.emit();
          },
          (error) => this.showErrorMessageWithTitle("Role saving error!", error),
        );
      } else {
        this.showErrorMessageWithTitle("Validation error!", "Role type not selected!");
      }
    }
  }

  public deleteRole(isConfirmed: boolean) {
    if (isConfirmed) {
      this.roleController.deleteRole(this.role.id).subscribe(
        () => {
          this.responseSuccessful("Role deleted!");
          this.router.navigate(["/services/" + this.serviceId + "/roles"]);
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public reloadRole() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.roleId = params.roleId;
      if (this.roleId) {
        this.roleController.getRole(this.roleId).subscribe(
          (data) => this.uploadData(data),
        );
      }
    });
  }

  public uploadData(role: Role) {
    this.role = role;
    this.statuses = this.sortStatusesByNumber(role.statuses);
    this.registrations = this.role.registrations;
  }

  public getServiceRolesList() {
    this.roleController.getRolesList(this.serviceId, false).subscribe(
      (data) => this.serviceRoles = data,
    );
  }

  public sortStatusesByNumber(statuses: any) {
    return statuses.sort((a, b) => {
      const textA = a.sortNumber;
      const textB = b.sortNumber;
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }

  public hasDeterminant(item: any) {
    if (!item.jsonDeterminants || item.jsonDeterminants === '[{"type":"OR","items":[]}]') {
      return false;
    }
    return true;
  }

  public removeDeterminant() {
    this.role.jsonDeterminants = "";
    this.saveRole();
  }

  public startEdit(event: any) {
    this.initialValue = event.target.value;
  }

  public submitEditOnFocus(event: any) {
    // Check if value has changed
    if (event.target.value !== this.initialValue) {
      this.initialValue = "";
      this.saveRole();
    }
  }

  public updateRoleUnitsLength(event: any) {
    this.roleUnitsLength = event.roleUnitsLength;
  }

  public openDetEdit() {
    this.store.state.common.sections.active = true;
    this.store.state.common.sections.type = "determinant";
  }
}
